<template>
  <modal
    v-slot="{ data }"
    name="reset-password-modal"
    modal-style="compact"
  >
    <reset-password :data="data" />
  </modal>
</template>


<script>
  import ResetPassword from './reset-password/index.vue';

  export default {
    name: 'ResetPasswordModal',

    components: {
      ResetPassword
    }
  };
</script>
